import { render, staticRenderFns } from "./BankStatsPanel.vue?vue&type=template&id=6a7d658a&scoped=true&"
import script from "./BankStatsPanel.vue?vue&type=script&lang=js&"
export * from "./BankStatsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7d658a",
  null
  
)

export default component.exports